<template>
  <div class="uikit-form">
    <h3 class="layout__subtitle">Спиннер</h3>

    <loader label="Данные загружаются" :active="true" height="300" />

    <div class="layout__hr"></div>

    <h3 class="layout__subtitle">Дефолтный аватар</h3>
    <img width="70px" :src="userpic" />

    <div class="layout__hr"></div>

    <h3 class="layout__subtitle">Кнопка "Наверх"</h3>

    <div>появится при скролле</div>
    <div style="height: 1000px"></div>

    <top-button root=".layout" />
  </div>
</template>

<script>
import Loader from "@/components/loader";
import TopButton from "@/components/top-button";
import defaultAvatar from "@/assets/images/userpic.svg";

export default {
  name: "uikit-other",

  components: {
    Loader,
    TopButton,
  },

  data() {
    return {
      buttons: {
        bookmark: false,
        filter: false,
        chart: false,
      },

      inputs: {
        simpleInput: "",
        clearableInput: "",
        searchInput: "",
        maskedInput: "",
      },

      selects: {
        groups: [
          { name: "category-1", label: "Первая категория" },
          { name: "category-2", label: "Вторая категория" },
          { name: "category-3", label: "Третья категория" },
        ],

        items: [
          { label: "Первый элемент", value: 1, group: "category-1" },
          { label: "Второй элемент", value: 2, group: "category-1" },
          { label: "Третий элемент", value: 3, group: "category-1" },
          { label: "Четвертый элемент", value: 4, group: "category-2" },
          { label: "Пятый элемент", value: 5, group: "category-2" },
          { label: "Шестой элемент", value: 6, group: "category-3" },
          { label: "Седьмой элемент", value: 7, group: "category-3" },
          { label: "Восмой элемент", value: 8, group: "category-3" },
        ],

        itemsWithCategorized: [
          { label: "Водитель", value: 1, isSubCategory: false, formatLabel: "<b>Водитель</b>" },
          { label: "Костюм", value: 2, isSubCategory: true, formatLabel: "<b>Водитель</b>/Костюм" },
          { label: "Пропускной талон", value: 3, isSubCategory: true, formatLabel: "<b>Водитель</b>/Пропускной талон" },
          { label: "Повар", value: 4, isSubCategory: false, formatLabel: "<b>Повар</b>" },
          { label: "Поварской китель", value: 5, isSubCategory: true, formatLabel: "<b>Повар</b>/Поварской китель" },
          { label: "Брюки поварские", value: 6, isSubCategory: true, formatLabel: "<b>Повар</b>/Брюки поварские" },
          { label: "Администратор", value: 7, isSubCategory: false, formatLabel: "<b>Администратор</b>" },
          {
            label: "Блузка администратора",
            value: 8,
            isSubCategory: true,
            formatLabel: "<b>Администратор</b>/Блузка администратора",
          },
        ],

        withCategorized: null,

        simpleSelectValue: { label: "Первый элемент", value: 1, group: "category-1" },

        clearableSelectValue: null,

        searchableSelectValue: null,

        multipleSelectValue: [],

        requiredSelectValue: [],

        reverseSelectValue: [],
        reverseValue: false,

        avatarSelectValue: [],

        multipleWithIconValue: [],

        multipleWithGroup: [],
      },

      datepickers: {
        simpleValue: "",
        editableValue: "",
        periodValue: "",
      },

      modals: {
        tableSettingsModal: {
          active: false,
        },

        createCategoryPositionsModal: {
          active: false,
          input: "Любое значение",
          groups: [
            { code: 1, label: "Производство", value: "1" },
            { code: 2, label: "Доставка", value: "2" },
            { code: 3, label: "Менеджмент", value: "3" },
          ],
        },

        removeCategoryPositionsModal: {
          active: false,
        },

        sidesheet: {
          active: false,
        },
      },
      defaultDisabledColumns: [],
      disabledColumns: [],
      userpic: defaultAvatar,
    };
  },

  computed: {},

  watch: {
    "datepickers.simpleValue": function (value) {
      console.log("value: ", value);
    },
  },

  methods: {
    closeRemoveItemPositionsModal() {
      this.modals.removeCategoryPositionsModal.active = false;
    },

    closeCreateItemPositionsModal() {
      this.modals.createCategoryPositionsModal.active = false;
    },

    closeSidesheet() {
      this.$emit("close");
      setTimeout(() => {
        this.modals.sidesheet.active = false;
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
</style>
